import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ISportConfigTab } from '../../../core/services/cms/models';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { GOLF_CONSTANTS } from '../../constants/channel.constant';
import { LocaleDirective } from '../../directives/locale.directive';

@Component({
    selector: 'see-all-link',
    template: '<a [i18n]="\'sb.seeAll\'" class="see-all-link" [routerLink]="link" (click)="sendGTMData()"></a> ',
    styleUrls: ['./see-all-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    imports: [LocaleDirective, RouterLink],
})
export class SeeAllLinkComponent {
    @Input() link?: string;
    @Input() targetTab: ISportConfigTab;
    @Input() sportId: string | number;
    @Input() eventType: { [key: string]: string };
    constructor(private gtmService: GtmService) {}
    sendGTMData(): void {
        if (this.sportId == '18') {
            const tabName = this.targetTab?.name;
            type GolfTabKey = keyof typeof GOLF_CONSTANTS;
            const event = tabName ? (GOLF_CONSTANTS[tabName as GolfTabKey] ?? tabName) : undefined;
            const gtmData = {
                'event': 'Event.Tracking',
                'component.CategoryEvent': 'navigation',
                'component.LabelEvent': 'golf',
                'component.ActionEvent': 'click',
                'component.PositionEvent': this.eventType,
                'component.LocationEvent': event,
                'component.EventDetails': 'see all',
                'component.URLClicked': 'Clicked URL',
            };
            this.gtmService.push(gtmData.event, gtmData);
        }
    }
}
